/* Dev-only logger: silent in production builds so no debug data leaks to the console. */
const dev = process.env.NODE_ENV !== "production";
const noop = () => {};

export const log = {
  error: dev ? (...a) => console.error(...a) : noop,
  warn: dev ? (...a) => console.warn(...a) : noop,
  info: dev ? (...a) => console.info(...a) : noop,
};
